export default {
  "subNavigation.users": "Users",
  "subNavigation.roles": "Roles",
  "subNavigation.userActivity": "User activity",
  "subNavigation.accountSettings": "Tenant Settings",
  "subNavigation.generalSettings": "General Settings",
  "subNavigation.appSettings": "App Settings",
  "subNavigation.fieldSettings": "Field Settings",
};
